exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".role-span{font-weight:bold;color:#303133;font-size:15px}", ""]);

// exports
